import React, { useState, useEffect } from "react";
import { Button, Layout, message, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar/sidebar";
import { BarsOutlined, MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import UserProfilePopup from "../../components/UserProfilePopup/userProfilePopup";
import { useSettings } from "../../contexts/settingsContext";
import { loadState } from "../../stores/store";
import { useUser } from "../../contexts/userContext";
import { checkContestantExists } from "../../api/user";
import { searchContestants } from "../../api/contestant";

const { Header, Content, Footer } = Layout;
const { Text } = Typography;

const Dashboard = ({ component: Outlet }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const { state: settings, dispatch } = useSettings();
    const [userRole, setUserRole] = useState(null);
    const [contestantExists, setContestantExists] = useState(true);
    const [contestant, setContestant] = useState(null);
    const navigate = useNavigate();
    const { user, setUser } = useUser(); 

    useEffect(() => {
        const fetchData = async () => {
            const user = loadState().user;
            setUser((prevState) => ({ ...prevState }));
            if (user && user.role) {
                setUserRole(user.role);
            }
            if (user.role === 'contestant') {
                const result = await checkContestantExists(user._id);
                if (!result.hasContestants) {
                    setContestantExists(false);
                    navigate('/new-contestant');
                } else {
                    setContestantExists(true);
                    const response = await searchContestants(user._id);
                    setContestant(response[0]);
                }
            }
        };
        fetchData();

    }, [settings.selectedRound, setUser]);

    if (!settings.selectedRound) {
        return <div>Loading...</div>;
    }

    const handleMobileTrigger = () => {
        setCollapsed(false);
        setExpanded(!expanded);
    }

    return (
        <Layout className="dashboard">
        {contestantExists && <Sidebar collapsed={collapsed} expanded={expanded} onExit={handleMobileTrigger} />}  
            <Layout>
                <Header className="dashboard_header" style={{ paddingLeft: 0, background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        {contestantExists && userRole !== 'judge' && <Button
                            type="text"
                            className="dashboard_header_trigger"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{
                                fontSize: '16px',
                                width: 64,
                                height: 64,
                            }}
                        />}
                        {contestantExists && (
                            <Button
                                type="text"
                                className="dashboard_header_mobile_trigger"
                                icon={<MenuOutlined />}
                                onClick={handleMobileTrigger}
                                style={{
                                    fontSize: '16px',
                                    width: 64,
                                    height: 64,
                                }}
                            />
                        )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                        <Text style={{ fontWeight: 'bold', fontSize: '16px', color: '#000000' }}>
                            {settings.selectedCompetition ? settings.selectedCompetition.name : "No competition selected"}
                        </Text>
                    </div>
                    <UserProfilePopup
                    contestant={contestant}
                    />
                </Header>
                <Content className="dashboard_content">
                    <div className="dashboard_content_container">
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default Dashboard;  
